import { useMemo, useRef, useState } from 'react';
import ScriptList from './scripts/ScriptList';
import ScriptEditor from './scripts/ScriptEditor';

// /scripts: the Scripts list and the script editor (?script=<id>), split into modules under pages/scripts/ (HD-7).
// Both stay mounted for the life of the route, as the old single component did: the list keeps its filters, selection
// and fetch while a script is open, and the editor keeps its unmount flush and its back-to-list on navigation. The
// two reach each other through refs; the page only wires them.
export default function Scripts() {
  const listRef = useRef(null);
  const editorRef = useRef(null);
  const [listLoad, setListLoad] = useState(true);
  const [editorOpen, setEditorOpen] = useState(false);

  // Stable forwarders, so neither side re-renders when the other's handle changes.
  const list = useMemo(() => ({
    loadScripts: (...a) => listRef.current?.loadScripts(...a),
    setScripts: (...a) => listRef.current?.setScripts(...a),
    setShowNew: (...a) => listRef.current?.setShowNew(...a),
    setNewScriptDefaults: (...a) => listRef.current?.setNewScriptDefaults(...a),
    setSaveTplPrompt: (...a) => listRef.current?.setSaveTplPrompt(...a),
  }), []);
  const selectScript = useMemo(() => (...a) => editorRef.current?.selectScript(...a), []);

  return (
    <>
      <ScriptList ref={listRef} hidden={editorOpen} onLoadChange={setListLoad}
        selectScript={selectScript} />
      <ScriptEditor ref={editorRef} listLoad={listLoad} onOpenChange={setEditorOpen}
        loadScripts={list.loadScripts} setScripts={list.setScripts} setShowNew={list.setShowNew}
        setNewScriptDefaults={list.setNewScriptDefaults} setSaveTplPrompt={list.setSaveTplPrompt} />
    </>
  );
}
